import styled from 'styled-components';

import { Flex } from '../Flex';

export const StyledTag = styled(Flex)``;
